// extracted by mini-css-extract-plugin
export default {"nav":"MobileNavBar_nav__FjEP+","nav__links":"MobileNavBar_nav__links__k-q7q","nav__link":"MobileNavBar_nav__link__EjSWQ","nav__close-icon":"MobileNavBar_nav__close-icon__CuF-m"};